module.exports = __webpack_public_path__ + "7bde12be2b69f49023585f311b93cbbe.fbx";